module.exports = __webpack_public_path__ + "img/pgtajc.f40f4590.png";